import { Moment } from "moment"
import { ArrowLeft, ArrowRight } from "../Icons"
import ButtonGroup from "../ButtonGroup"
import styles from "./DateNavigation.module.scss"

type CalendarView = "month" | "week" | "day"

type DateNavigationProps = {
  startDate: Moment
  endDate: Moment
  calendarView: CalendarView
  onDateRangeChange: (startDate: Moment, endDate: Moment) => void
  onCalendarViewChange: (view: CalendarView) => void
}

const DateNavigation = ({
  startDate,
  endDate,
  calendarView,
  onDateRangeChange,
  onCalendarViewChange,
}: DateNavigationProps) => {
  const calendarOptions = [
    { label: "Month", value: "month" as CalendarView },
    { label: "Week", value: "week" as CalendarView },
    { label: "Day", value: "day" as CalendarView },
  ]

  const formatCurrentPeriod = () => {
    if (calendarView === "day") {
      return startDate.format("MMMM DD, YYYY")
    } else if (calendarView === "week") {
      if (startDate.month() === endDate.month()) {
        return `${startDate.format("MMMM DD")} - ${endDate.format("DD, YYYY")}`
      } else {
        return `${startDate.format("MMM DD")} - ${endDate.format("MMM DD, YYYY")}`
      }
    } else {
      return startDate.format("MMMM YYYY")
    }
  }

  const navigateDate = (direction: "prev" | "next") => {
    let newStartDate: Moment
    let newEndDate: Moment

    const increment = direction === "next" ? 1 : -1

    switch (calendarView) {
      case "month":
        newStartDate = startDate.clone().add(increment, "month").startOf("month")
        newEndDate = newStartDate.clone().endOf("month")
        break
      case "week":
        newStartDate = startDate.clone().add(increment, "week").startOf("week")
        newEndDate = newStartDate.clone().endOf("week")
        break
      case "day":
        newStartDate = startDate.clone().add(increment, "day").startOf("day")
        newEndDate = newStartDate.clone().endOf("day")
        break
      default:
        return
    }

    onDateRangeChange(newStartDate, newEndDate)
  }

  return (
    <div className={styles.dateNavigationContainer}>
      <ButtonGroup
        options={calendarOptions}
        selectedValue={calendarView}
        onClick={(value) => onCalendarViewChange(value as CalendarView)}
      />

      <div className={styles.dateNavigation}>
        <button
          type="button"
          className={styles.navButton}
          onClick={() => navigateDate("prev")}
          title="Previous"
        >
          <ArrowLeft />
        </button>

        <span className={styles.periodLabel}>{formatCurrentPeriod()}</span>

        <button
          type="button"
          className={styles.navButton}
          onClick={() => navigateDate("next")}
          title="Next"
        >
          <ArrowRight />
        </button>
      </div>
    </div>
  )
}

export default DateNavigation
